export enum TimezoneNames {
  ET = 'Eastern',
  CT = 'Central',
  MT = 'Mountain',
  PT = 'Pacific',
  AL = 'Alaska',
  HI = 'Hawaii',
  AT = 'Atlantic'
}

// Legacy IANA-tag -> display-name lookup, retained only for the three consumers below against the
// fixed provider timezone set. Display labels are derived from Intl via deriveTimezoneDisplayName
// (helpers/timezone-display-name.ts), which needs no per-zone table; do not add zones here to fix a
// missing label -- derive from Intl instead. Remove this map once these consumers migrate off it:
//   - calendar-working-hours.component.ts (TimezoneTagToNameMap[timezone] ?? '')
//   - requested-time-slot.pipe.ts (guards on TimezoneTagToNameMap[timeZone])
//   - calendar-working-hours-timezone-select.component.ts (Object.keys(...) for the select order --
//     its insertion order is load-bearing, so do not reorder these entries)
export const TimezoneTagToNameMap: { [key: string]: string; } = {
  'America/New_York': TimezoneNames.ET,
  'America/Chicago': TimezoneNames.CT,
  'America/Indiana/Indianapolis': TimezoneNames.ET,
  // Legacy IANA link alias for America/Indiana/Indianapolis; retained for records storing the old tag.
  'America/Indianapolis': TimezoneNames.ET,
  'America/Phoenix': TimezoneNames.MT,
  'America/Denver': TimezoneNames.MT,
  'America/Los_Angeles': TimezoneNames.PT,
  'America/Juneau': TimezoneNames.AL,
  'Pacific/Honolulu': TimezoneNames.HI,
};
